const initComunidadDiscord = () => {
  const comunidadDiscord = document.querySelector('.mi-cuenta__comunidad');
  if (!comunidadDiscord) return;

  const btnSinCuenta = comunidadDiscord.querySelector('.sin-cuenta .btn');
  const btnConCuenta = comunidadDiscord.querySelector('.con-cuenta .btn');

  if (btnSinCuenta) {
    btnSinCuenta.addEventListener('click', () => { 
      const scrVideo = btnSinCuenta.getAttribute('data-href');

      if (scrVideo) {
        setVideo(scrVideo)
      }
    });
  }

  if (btnConCuenta) {
    btnConCuenta.addEventListener('click', () => {
      const scrVideo = btnConCuenta.getAttribute('data-href');

      if (scrVideo) {
        setVideo(scrVideo)
      }
    });
  }

  function setVideo(scrVideo) {
    const videoContainer = document.querySelector('.mi-cuenta__comunidad-video .video-container');
    if (videoContainer) {
      videoContainer.innerHTML = `<iframe class="video-comunidad" src="${scrVideo}" title="Comunidad video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      
      videoContainer.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

export default initComunidadDiscord;